import { Otp } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { usePhoneOtp, useSetUserPhone } from '@repo/services'
import { Button, Card, Col, Icon, toast } from '@repo/ui/components'
import { useRef, useState } from 'react'
import { IMobileKycOtpProps } from './mobile-kyc.types'
import { normalizeMobile } from '@repo/ui/lib'
import { useErrorHandler } from '@repo/shared/hooks'
export const MobileKycOtp = (props: IMobileKycOtpProps) => {
  const { mobile, otp, handleBack } = props
  const { t } = useTranslate()
  const { push } = useRouter()
  const [otpCode, setOtpCode] = useState<string>('')
  const phoneOtpMutation = usePhoneOtp()
  const setUserPhoneMutation = useSetUserPhone({ invalidate: true })
  const { errorHandler } = useErrorHandler()
  const submitRef = useRef(null)

  const handleResend = () => {
    phoneOtpMutation.mutate(
      { phone: normalizeMobile(mobile) },
      { onError: errorHandler },
    )
  }

  const handleOtpComplete = (code: string) => {
    setOtpCode(code)
  }

  const handleSubmit = async (code: string = otpCode) => {
    if (!code || code.length !== 5) return
    setUserPhoneMutation.mutate(
      { phone: normalizeMobile(mobile), otp: Number(otp), code },
      {
        onError: errorHandler,
        onSuccess: () => {
          toast.success({
            title: t('mobileKyc_success'),
          })
          setUserPhoneMutation.reset()
          push(`/auth/kyc?mobileOrEmail=${mobile}`)
        },
      },
    )
  }

  return (
    <Card className='p-xl rounded-sm'>
      <Col className='gap-3xl'>
        <Button
          startIcon={<Icon name='ArrowRightLine' />}
          variant='transparent'
          size='xs'
          onClick={handleBack}
          className='gap-2xs'
        >
          {t('common_back')}
        </Button>
        <Otp
          mobileOrEmail={mobile}
          onResend={handleResend}
          onComplete={handleOtpComplete}
          focusRef={submitRef}
        />
        <Button
          ref={submitRef}
          size='lg'
          className='w-full'
          onClick={() => handleSubmit()}
          disabled={otpCode.length !== 5}
          loading={setUserPhoneMutation.isPending}
        >
          {t('common_verify')}
        </Button>
      </Col>
    </Card>
  )
}
